<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>子账号列表</h6>
      <p class="text-xs text-secondary">按商户归集，点击商户行可展开/收起该商户下的所有子账号</p>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border text-primary" role="status"><span class="visually-hidden">加载中...</span></div>
      </div>
      <div v-else-if="merchantGroups.length === 0" class="text-center text-secondary py-4">暂无子账号数据</div>
      <div v-else>
        <div v-for="(group, gIndex) in paginatedGroups" :key="group.deliver_id" class="border-bottom">
          <!-- 商户折叠头 -->
          <div
            class="d-flex align-items-center justify-content-between px-3 py-2"
            style="cursor: pointer; background: #f8f9fa;"
            @click="toggleGroup(gIndex)"
          >
            <div class="d-flex align-items-center">
              <i :class="group.expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" class="me-2 text-secondary text-xs"></i>
              <soft-avatar :img="defaultAvatar" size="sm" border-radius="lg" class="me-3" alt="merchant" />
              <div>
                <h6 class="mb-0 text-sm">{{ group.display_name || ('商户#' + group.deliver_id) }}</h6>
                <p class="text-xs text-secondary mb-0">
                  <span class="me-2">ID: {{ group.deliver_id }}</span>
                </p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <span class="badge bg-primary me-2">{{ group.users.length }} 个子账号</span>
            </div>
          </div>
          <!-- 展开的子账号列表 -->
          <div v-if="group.expanded" class="table-responsive">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">头像</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">账号ID</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">昵称</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">登录账号</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">入驻时间</th>
                  <th class="text-secondary opacity-7"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(author, index) in group.users" :key="author.account_id">
                  <td>
                    <div class="d-flex px-2 py-1">
                      <div>
                        <soft-avatar :img="defaultAvatar" size="sm" border-radius="lg" class="me-3" alt="avatar" />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex px-2 py-1">
                      <div>
                        <h6 class="mb-0 text-sm">{{ author.account_id }}</h6>
                      </div>
                    </div>
                  </td>
                  <td>
                    <p class="text-xs font-weight-bold mb-0">{{ author.nick_name }}</p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <p class="text-xs text-secondary mb-0">{{ author.account }}</p>
                  </td>
                  <td class="align-middle text-center">
                    <span class="text-secondary text-xs font-weight-bold">{{ formattedDate(author.created_date) }}</span>
                  </td>
                  <td class="align-middle">
                    <soft-button
                      @click="toggleMenu(group.deliver_id + '_' + index)"
                      class="text-secondary font-weight-bold text-xs"
                      :style="{backgroundColor: menuVisibleKey === (group.deliver_id + '_' + index) ? '#f1f1f1' : '',
                        color: menuVisibleKey === (group.deliver_id + '_' + index) ? '#6c757d' : 'white'}">
                      {{ menuVisibleKey === (group.deliver_id + '_' + index) ? '操作' : '操作>>' }}
                    </soft-button>
                    <div v-if="menuVisibleKey === (group.deliver_id + '_' + index)" class="menu">
                      <ul>
                        <li @click="editPassword(author)" style="margin-left:-10px;">修改密码</li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Pagination Controls -->
      <div class="d-flex justify-content-between align-items-center mt-3 px-3">
        <button class="btn btn-outline-dark" @click="changePage(currentPage - 1)" :disabled="currentPage <= 1" style="margin-right: 20px;">
          上一页
        </button>
        <div class="text-center">
          第 {{ currentPage }} 页/ 总 {{ totalPages }} 页（共 {{ merchantGroups.length }} 个商户）
        </div>
        <button class="btn btn-outline-dark" @click="changePage(currentPage + 1)" :disabled="currentPage >= totalPages" style="margin-left: 20px;">
          下一页
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import { getsubuserlist, setsubuserpassword } from "@/api/user.js"
import { getMerchantDisplayName } from "@/utils/merchantCache"
import SoftButton from "@/components/SoftButton.vue"
import dayjs from "dayjs";
import md5 from 'md5'

export default {
  name: "users-table",
  data() {
    return {
      defaultAvatar: require("../../../assets/img/merchant.png"),
      authors: [],
      merchantGroups: [],
      loading: false,
      currentPage: 1,
      groupsPerPage: 10,
      menuVisibleKey: null,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.merchantGroups.length / this.groupsPerPage) || 1;
    },
    paginatedGroups() {
      const start = (this.currentPage - 1) * this.groupsPerPage;
      const end = start + this.groupsPerPage;
      return this.merchantGroups.slice(start, end);
    }
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },

    toggleGroup(gIndex) {
      this.paginatedGroups[gIndex].expanded = !this.paginatedGroups[gIndex].expanded;
    },

    async handleSearch() {
      this.loading = true;
      try {
        const response = await getsubuserlist({});
        if (response.code === 0) {
          this.authors = response.desc || [];
          this.buildMerchantGroups();
        } else {
          alert(response.desc);
        }
      } catch (error) {
        console.log('error fetching user data:', error);
      } finally {
        this.loading = false;
      }
    },

    buildMerchantGroups() {
      const groupMap = {};
      this.authors.forEach(author => {
        const did = author.deliver_id;
        if (!groupMap[did]) {
          groupMap[did] = {
            deliver_id: did,
            merch_name: '',
            merch_nick_name: '',
            users: [],
            expanded: false,
          };
        }
        groupMap[did].users.push(author);
      });
      this.merchantGroups = Object.values(groupMap);
      this.currentPage = 1;
      this.fetchMerchantNames();
    },

    async fetchMerchantNames() {
      for (const group of this.merchantGroups) {
        try {
          group.display_name = await getMerchantDisplayName(group.deliver_id, '商户#' + group.deliver_id);
        } catch (error) {
          console.log("get merchant display name err:", error);
          group.display_name = '商户#' + group.deliver_id;
        }
      }
    },

    toggleMenu(key) {
      this.menuVisibleKey = this.menuVisibleKey === key ? null : key;
    },

    editPassword(author) {
      const newPassword = prompt("请输入新密码：");
      if (!newPassword) {
        alert("新密码不能为空！");
        return;
      }
      if (confirm(`您确定要修改账号 ${author.account} 的密码吗？`)) {
        this.changePassword(author, newPassword);
      }
    },

    formattedDate(timestamp) {
      return dayjs.unix(timestamp).format('YYYY/MM/DD HH:mm:ss');
    },

    changePassword(author, newPassword) {
      const userAccount = author.account;
      const userPass = md5(userAccount + newPassword);

      const params = {
        sub_id: author.account_id,
        newpass: userPass,
      };

      setsubuserpassword(params)
        .then(response => {
          if (response.code === 0) {
            alert("密码修改成功！");
          } else {
            alert("密码修改失败：" + response.desc);
          }
        })
        .catch(error => {
          console.error("修改密码时出错：", error);
          alert("密码修改失败，请稍后再试。");
        });
    },
  },
  components: {
    SoftAvatar,
    SoftButton,
  },
  mounted() {
    this.handleSearch();
  }
};
</script>

<style scoped>
.d-flex {
  display: flex;
  align-items: center;
}

.form-select, .form-control {
  vertical-align: middle;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
}

menu {
  position: absolute;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 5px;
  z-index: 10;
  max-width: 80px;
}

.menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  max-width: 80px;
}

.menu ul li {
  padding: 8px 16px;
  cursor: pointer;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8rem;
  border-radius: 0.5rem;
  text-align: center;
  padding: 5px;
  margin-top: 8px;
}

.menu ul li:hover {
  background-color: #f1f1f1;
}
</style>
